<form #form ngNoForm [action]="exactPaymentPath" method="post">
  <input name="x_login" [value]="exactForm.transactionLogin" type="hidden" />
  <input name="x_amount" [value]="exactForm.paymentAmount" type="hidden" />
  <input name="x_fp_sequence" [value]="exactForm.fpSequence" type="hidden" />
  <input name="x_currency_code" [value]="exactForm.currency" type="hidden" />
  <input id="timestamp" name="x_fp_timestamp" [value]="exactForm.timestamp" type="hidden" />
  <input id="hash" name="x_fp_hash" [value]="exactForm.hash" type="hidden" />
  <input name="x_show_form" [value]="exactForm.showForm" type="hidden" />
  <input name="x_type" [value]="exactForm.type" type="hidden" />
  <input name="x_receipt_link_method" [value]="exactForm.receiptLinkMethod" type="hidden" />
  <input name="x_receipt_link_text" [value]="exactForm.receiptLinkText" type="hidden" />
  <input name="x_receipt_link_url" [value]="exactForm.receiptLinkUrl" type="hidden" />
  <input name="x_relay_response" value="TRUE" type="hidden" /> <input name="x_invoice_num" type="hidden" />
  <input name="x_description" [value]="exactForm.description" type="hidden" />
</form>
